/**
 * The product's name as the web app shows it: the sign-in screens, the app shell's logo and the
 * browser tab. One constant so a rename is one edit. `index.html`'s `<title>` repeats it by hand
 * (it is served before any script runs).
 */
export const PRODUCT_NAME = 'PeopleOrbit';
